import { render, staticRenderFns } from "./action-panel.vue?vue&type=template&id=29780f6a&"
import script from "./action-panel.vue?vue&type=script&lang=js&"
export * from "./action-panel.vue?vue&type=script&lang=js&"
import style0 from "./action-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29780f6a')) {
      api.createRecord('29780f6a', component.options)
    } else {
      api.reload('29780f6a', component.options)
    }
    module.hot.accept("./action-panel.vue?vue&type=template&id=29780f6a&", function () {
      api.rerender('29780f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/nav/action-panel.vue"
export default component.exports